const websiteConfig = {
  state: {
    themeColor: "", // 主题色
    config: {
      window: {
        leftBarBackgroundColor: "",
        leftBarTextColor: "",
        leftBarTextActiveColor: ""
      },
      loginEntryPagePath: ""
    } // 网站配置
  },
  mutations: {
    // 网站配置
    SET_WEBSITECONFIG: (state, data) => {
      state.config = data;
    },
    // 主题色
    SET_THEMECOLOR: (state, color) => {
      state.themeColor = color;
    }
  },
  actions: {
    // 设置网站配置
    setWebsiteConfig({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_WEBSITECONFIG", data);
        commit("SET_THEMECOLOR", data.window.themeColor);
        resolve();
      });
    }
  }
};

export default websiteConfig;



// WEBPACK FOOTER //
// ./src/store/modules/websiteConfig.js